exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".applicationInstructionContaier_nNMmk {\n    padding: 30px 80px !important;\n    font-size: 16px;\n    letter-spacing: 0.3px;\n}\n\n.applicationInstructionContaier_nNMmk li {\n    padding: 20px 0;\n}\n\n.applicationInstructionContaier_nNMmk > p {\n    padding: 20px 40px;\n}\n\n.gapSection1_GVWFI {\n    height: 390px;\n}\n", ""]);

// exports
exports.locals = {
	"applicationInstructionContaier": "applicationInstructionContaier_nNMmk",
	"gapSection1": "gapSection1_GVWFI"
};